/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Happy",
  size: 20
}

const SvgHappy = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle cx={13} cy={7} r={1} />
    <circle cx={7} cy={7} r={1} />
    <circle fill="none" cx={10} cy={10} r={8.5} />
    <path
      fill="none"
      d="M14.6 11.4c-.7 1.9-2.5 3.1-4.6 3.1-2.1 0-3.9-1.2-4.6-3.1"
    />
  </Svg>
)

SvgHappy.defaultProps = defaultProps
export default SvgHappy
